const teamManagement = {
  title: "إدارة الفريق",
  tabs: {
    employees: "إدارة الموظفين",
    roles: "إدارة الأدوار",
  },
  rowsPerPageLabel: "عدد الصفوف",
  employees: {
    searchPlaceholder: "ابحث عن موظف",
    addEmployee: "إضافة موظف",
    table: {
      name: "اسم الموظف",
      email: "البريد الإلكتروني",
      mobileNumber: "رقم الجوال",
      role: "الدور",
      actions: "الإجراءات",
      edit: "تعديل",
      remove: "إزالة",
    },
    rangeTemplate: "عرض {from}-{to} من {total} موظف",
    emptyTitle: "لا يوجد موظفون بعد",
    emptyDescription:
      "هل ترغب في إضافة موظفين جدد؟ بمجرد إضافتهم، سيظهرون في هذا الجدول.",
    searchEmptyTitle: "عذرًا، لم يتم العثور على موظفين.",
    deleteModal: {
      title: "إزالة موظف",
      question: 'هل أنت متأكد من إزالة "{name}"؟',
      cancel: "إلغاء",
      delete: "إزالة",
    },
  },
  roles: {
    searchPlaceholder: "ابحث عن دور",
    createRole: "إنشاء دور جديد",
    table: {
      name: "الدور",
      usersCount: "عدد المستخدمين",
      status: "الحالة",
      actions: "الإجراءات",
      edit: "تعديل",
      remove: "حذف",
    },
    rangeTemplate: "عرض {from}-{to} من {total} دور",
    emptyTitle: "لا توجد أدوار بعد",
    emptyDescription:
      "هل ترغب في إنشاء أدوار جديدة؟ بمجرد إنشائها، ستظهر في هذا الجدول.",
    searchEmptyTitle: "عذرًا، لم يتم العثور على أدوار.",
    deleteModal: {
      title: "حذف الدور",
      question: 'هل أنت متأكد من حذف "{role}"؟',
      blockedMessage:
        'الدور "{role}" مُسند إلى {count} مستخدم ولا يمكن حذفه. أعد إسناد هؤلاء المستخدمين إلى دور آخر أولًا.',
      cancel: "إلغاء",
      delete: "حذف",
    },
  },
  createRole: {
    title: "إنشاء دور جديد",
    subtitle: "اضبط الاسم ومستويات الوصول التفصيلية لهذا الدور.",
    roleNameLabel: "اسم الدور",
    roleNamePlaceholder: "أدخل اسم الدور",
    roleNameRequired: "اسم الدور مطلوب",
    modulesHeader: "الوحدات",
    moduleCount: "{count} وحدات",
    lockedHint: "تم منحه تلقائيًا بواسطة صلاحية أخرى قمت باختيارها.",
    levels: {
      view: "عرض",
      add: "إضافة",
      edit: "تعديل",
      delete: "حذف",
    },
    groups: {
      coreOperations: "العمليات الأساسية",
      hrFinance: "الموارد البشرية والمالية",
      managements: "الإدارة",
      analyticsReports: "التحليلات والتقارير",
    },
    modules: {
      applicants: "المتقدمون الموالون",
      employees: "الموظفون",
      joiningEvents: "المتقدمون للفعالية",
      events: "الفعاليات",
      payroll: "الرواتب",
      timesheet: "سجل الدوام",
      manageClients: "إدارة العملاء",
      manageReports: "إدارة التقارير",
      evaluations: "التقييمات",
      reports: "التقارير",
      surveyScore: "درجة الاستبيان",
      heatmap: "الخريطة الحرارية",
      rolesManagement: "إدارة الأدوار",
    },
    cancel: "إلغاء",
    submit: "إنشاء الدور",
  },
  addEmployee: {
    title: "إضافة موظف جديد",
    detailsTitle: "التفاصيل",
    pictureLabel: "صورة شخصية",
    uploadPicture: "رفع صورة",
    changePicture: "تغيير",
    uploading: "جارٍ الرفع",
    fields: {
      name: "الاسم",
      namePlaceholder: "أدخل الاسم الكامل",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل البريد الإلكتروني",
      mobileNumber: "رقم الجوال",
      role: "الدور",
      rolePlaceholder: "اختر الدور",
    },
    validations: {
      nameRequired: "الاسم مطلوب",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailInvalid: "يرجى إدخال بريد إلكتروني صحيح",
      roleRequired: "الدور مطلوب",
      phoneRequired: "رقم الجوال مطلوب",
    },
    cancel: "إلغاء",
    submit: "إضافة",
    createSuccess: "تم إنشاء ملف الموظف بنجاح.",
  },
  viewEmployee: {
    title: "ملف الموظف",
    detailsTitle: "التفاصيل",
    idLabel: "الرقم:",
    editProfile: "تعديل الملف",
    deleteEmployee: "حذف الموظف",
    emptyValue: "—",
    cancel: "إلغاء",
    update: "تحديث",
    updateSuccess: "تم تحديث ملف الموظف بنجاح.",
    fields: {
      name: "الاسم",
      email: "البريد الإلكتروني",
      mobileNumber: "رقم الجوال",
      role: "الدور",
    },
  },
  viewRole: {
    titleTemplate: "تفاصيل دور {name}",
    subtitle: "اعرض الصلاحيات ومستويات الوصول التفصيلية لهذا الدور.",
    roleNameLabel: "اسم الدور",
    editPermissions: "تعديل الصلاحيات",
    updatePermissions: "تحديث الصلاحيات",
    cancel: "إلغاء",
    updateSuccess: "تم تحديث صلاحيات {name} بنجاح!",
  },
};

export default teamManagement;
